<template>
  <page-article class="campus_recruiting_content_area page_article_block">
    <portlet>
      <div class="col-12">
        <enterprise-edit-career-expo
          :enrolled-expo-info="currentExpoGetter"
          @booths:changed="boothQuantityUpdated"
        />
      </div>
      <div class="col-12 text-center">
        <button-wrapper
          @click.prevent="submitCareerExpo"
        >
          確定修改
        </button-wrapper>
      </div>
    </portlet>
  </page-article>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import pageArticle from '~components/pages/Article'
import Portlet from '~components/common/Portlet'
import ButtonWrapper from '~components/common/buttons'
import EnterpriseEditCareerExpo from '../common/EnterpriseEditCareerExpo'
export default {
  name: 'EnterpriseCareerExpoDetailsContent',
  components: {
    pageArticle,
    Portlet,
    ButtonWrapper,
    EnterpriseEditCareerExpo
  },
  data () {
    return {
      careerExpo: {}
    }
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentExpoGetter'
    ]),
    ...mapGetters('pages/campus-recruiting', [
      'currentRecruitmentGetter',
      'currentExpoInfoGetter'
    ])
  },
  async created () {
    this.togglePageLoader(true)
    if (Object.keys(this.currentRecruitmentGetter).length < 1) {
		try {
			await this.getRecruitmentDetailsById(this.$route.params.id)
			await this.getEnrolledCampusRecruitmentById(this.$route.params.id)
		}
		catch (err) {
			this.$router.push('/campus-recruiting');
		}
    }
    this.togglePageLoader(false)
  },
  methods: {
    ...mapActions('pages/enterprises', [
      'modifyOrderById',
      'getEnrolledCampusRecruitmentById'
    ]),
    ...mapActions('pages/campus-recruiting', [
      'getRecruitmentDetailsById'
    ]),
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    boothQuantityUpdated (careerExpo) {
      this.careerExpo = Object.assign({}, careerExpo)
    },
    async submitCareerExpo () {
      await this.modifyOrderById({
        campus_recruitment_id: this.currentRecruitmentGetter.recruitment_id,
        careerExpo: this.careerExpo
      })
      this.$router.push({
        path: `/campus-recruiting/${this.$route.params.id}/enterprise`,
        query: {
          tab: '報名紀錄'
        }
      })
    }
  }
}
</script>
